import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store, { setupStore } from './store'
import { globalRegister } from '@/global'
import 'normalize.css'
import './assets/css/index.less'
import 'animate.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// 导入 Element Plus 图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

// 注册自定义指令（如 v-permission）
globalRegister(app)
app.use(store)
setupStore() // store里面会动态加载路由，因此需要在router之前调用
app.use(router)
// ✅ 关键：使用官方注册方式（自动注册所有组件和指令）
app.use(ElementPlus, {
  locale: zhCn
  // 其他配置项（如 size, zIndex 等）
})

// 引入图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app')

// lcRequest.request({
//   url: '/get',
//   method: 'GET',
//   showLoading: true,
//   interceptors: {
//     requestInterceptor: (config) => {
//       console.log('发送成功')
//       return config
//     }
//   }
// })
